import React from "react";
import configData from "../appconfig/config.json";

const errorscreen = (props) => {
  const toMaybankHome = () => {
    document.location.href = configData.URL_NAVIGATE_COB;
  };
  return (
    <div className=" mt-3">
      <div className="outerdivsubheader">
        <div className="row">
          <div className="col-12">
            <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
          </div>
        </div>
        <div className="DynaForm DynamicFields">
          <div className="col-12">
            <p className="Dynamiccenteralign mb-0">{configData.APP_NAMEHDR}</p>
          </div>
          <hr className="panelLine"></hr>
          <div
            className="panel-collapse collapse in"
            style={{ padding: "10px" }}
          >
            <div className="panel-body" style={{ padding: "25px" }}>
              <div className="DynamicFieldstretchRuIL  flex-row">
                <div className="Dynamiccenteralign" style={{ padding: "10px" }}>
                  <h2> Sorry, we are unable to process your information.</h2>
                </div>
              </div>
              <div className="DynamicFieldstretchRuIL  flex-row">
                <div className="Dynamiccenteralign" style={{ padding: "10px" }}>
                  <h3 style={{ fontWeight: "600" }}>
                    {" "}
                    You can apply using our online form instead:
                  </h3>
                  <p>Get in touch at 1800-629-2265 if you have any quiries</p>
                </div>
              </div>

              <br></br>

              <div className="DynamicFieldstretchRuIL flex-row">
                <button
                  type="button"
                  onClick={toMaybankHome}
                  id="backtoHomebtn"
                  className="null  btn btn-success"
                >
                  Using Online form
                </button>
              </div>
              <br></br>

              <div className="DynamicFieldstretchRuIL flex-row">
                <p className="note1">
                  Note : For foreigners, please visit any Maybank branch to
                  apply.
                </p>
              </div>
              <div className="DynamicFieldstretchRuIL flex-row">
                <p className="brchLink">
                  <a
                    id="locationToBranch"
                    href="https://www.maybank2u.com.sg/en/personal/about_us/Locate-Us.page?"
                    className="removecolorofanchor"
                  >
                    Click here for Branch Locater
                  </a>
                </p>
              </div>

              <div className="well welcomeNote" style={{ padding: "10px" }}>
                <div className="row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default errorscreen;
